import {SET_CURRENT_ROUTE, SET_SIDE_BAR_OPEN,AUTH_USER, UNAUTH_USER, AUTH_ERROR} from '../actions/types';

const initialState = { routeName: "create_plano_campaign", sideBarOpen: false };

export default (state = initialState, action)=>{
    switch(action.type){
        case SET_CURRENT_ROUTE : {
            return { ...state, routeName : action.payload}
        }
        case SET_SIDE_BAR_OPEN : {
            return { ...state, sideBarOpen : action.payload}
        }
        case AUTH_USER:
            return { ...state, error:'', authenticated: true, user:action.payload };
         case UNAUTH_USER:
            return { ...state, authenticated: false };
        case AUTH_ERROR:
            return { ...state, error: action.payload };

        default : {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/v3/reducers/authReducer.js